import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { EventsPage } from './pages/EventsPage';
import { FloatingJoinButton } from './components/FloatingJoinButton';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<BeachClubPage data-id="element-3" />} data-id="element-2" />
        <Route path="/sup" element={<SUPPage data-id="element-5" />} data-id="element-4" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-7" />} data-id="element-6" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-9" />} data-id="element-8" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-11" />} data-id="element-10" />
        <Route path="/events" element={<EventsPage data-id="element-13" />} data-id="element-12" />
      </Routes>
      <FloatingJoinButton data-id="element-14" />
    </Router>;
}